import { supabase } from '../supabase';

/**
 * Download access for Choir Center Subscription Model.
 * - Choir Member (free): 2 downloads/month
 * - Choir Supporter: unlimited downloads within 1 month
 * - Choir Expert: unlimited downloads within 1 year
 * - Admin: unlimited downloads forever
 */
export async function handleSongDownload(song, user, setPromptType, setShowPrompt) {
  if (!user) {
    setPromptType && setPromptType('register');
    setShowPrompt && setShowPrompt(true);
    return { allowed: false, reason: 'not_logged_in' };
  }

  const now = new Date(); // <-- Moved here to fix ReferenceError!

  // Check if user is an admin
  const { data: adminData, error: adminError } = await supabase
    .from('admins')
    .select('user_id')
    .eq('user_id', user.id)
    .single();

  if (adminData && !adminError) {
    // Admin has unlimited downloads forever
    await supabase
      .from('songs')
      .update({
        downloads: (song.downloads || 0) + 1,
        updated_at: now.toISOString(),
      })
      .eq('id', song.id);

    return {
      allowed: true,
      reason: 'ok',
      updatedSong: { ...song, downloads: (song.downloads || 0) + 1 },
      tier: 'admin'
    };
  }

  // Fetch profile (subscription status)
  const { data: profile, error: profileError } = await supabase
    .from('profiles')
    .select('subscription_tier, subscription_expires_at, download_count_month, last_download_month')
    .eq('id', user.id)
    .single();

  if (profileError || !profile) {
    alert("Failed to check your profile.");
    return { allowed: false, reason: 'profile_fetch_failed' };
  }

  const tier = profile.subscription_tier || 'choir_member';
  const expiry = profile.subscription_expires_at ? new Date(profile.subscription_expires_at) : null;
  const thisMonth = `${now.getFullYear()}-${String(now.getMonth() + 1).padStart(2, '0')}`;
  let userCount = profile.download_count_month || 0;
  let userMonth = profile.last_download_month || "";

  // Check subscription and expiry for supporter/expert
  if (
    (tier === 'choir_supporter' || tier === 'choir_expert') &&
    expiry &&
    expiry > now
  ) {
    // Unlimited download, but increment the song's download count
    await supabase
      .from('songs')
      .update({
        downloads: (song.downloads || 0) + 1,
        updated_at: now.toISOString(),
      })
      .eq('id', song.id);

    return {
      allowed: true,
      reason: 'ok',
      updatedSong: { ...song, downloads: (song.downloads || 0) + 1 },
      tier
    };
  }

  // Free user: 1 download per month
  if (userMonth !== thisMonth) userCount = 0;
  const maxDownloads = 1;

  if (userCount >= maxDownloads) {
    setPromptType && setPromptType('subscribe');
    setShowPrompt && setShowPrompt(true);
    return { allowed: false, reason: 'limit_reached', tier: 'choir_member' };
  }

  // INCREMENT COUNTS (for free user)
  await supabase
    .from('profiles')
    .update({
      download_count_month: userCount + 1,
      last_download_month: thisMonth,
    })
    .eq('id', user.id);

  await supabase
    .from('songs')
    .update({
      downloads: (song.downloads || 0) + 1,
      updated_at: now.toISOString(),
    })
    .eq('id', song.id);

  return {
    allowed: true,
    reason: 'ok',
    updatedSong: { ...song, downloads: (song.downloads || 0) + 1 },
    tier: 'choir_member'
  };
}
